import { getRuntimeTheme } from '../runtimeEnv'

const LEGISLATION = {
  bc: {
    name: 'FIPPA',
    redactionExample: 'FIPPA s. 22(1)'
  },
  saskatchewan: {
    name: 'LA FOIP',
    redactionExample: 'LA FOIP s. 28(1)'
  }
}

export function getLegislation(themeName = getRuntimeTheme()) {
  return themeName === 'saskatoonfoi' ? LEGISLATION.saskatchewan : LEGISLATION.bc
}
